import { apiPost } from "../ApiMethod";
import { setDroneNest } from "../../mappers";

export const createDroneNest = async (data) => {
  const response = await apiPost("_dronenest", data);
  return { ...response, data: setDroneNest(response.data) };
};
